export const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3200/api/v1';

export const PAYMENT_CONFIG = {
  enableSandbox: import.meta.env.VITE_PAYMENT_SANDBOX === 'true',
};
